import React, { Component } from 'react';
import './CreatorPlatform.css';
import CreatorUpload from './CreatorUpload';
import PlatformSidebar from './PlatformSidebar';
import Onboarding from './Onboarding.js';
import AddFunds from './AddFunds.js';
import ImportFromPassword from './ImportFromPassword';
import NounsUploadForm from './NounsUploadForm';
import NounsAccordion from './NounsAccordion.js';

class NounsUploadPage extends Component {
  constructor(props) {
    super(props);
    this.selectModal = this.selectModal.bind(this);

    this.state = {
      modalShown: '',
    }
  }

  selectModal(modal) {
    this.setState({
      modalShown: modal,
    });
  }

  render() {
    return (
      <div className="min-h-screen">
        <div>
          <PlatformSidebar
            modalShown={this.state.modalShown}
            selectModal={this.selectModal}
          />
          <div className="flex w-screen justify-center">
          <div className="w-0 xl:w-1/3">

          </div>
          <div className="xl:w-5/12 lg:w-6/12 flex items-center justify-center border-0 lg:border-white-600 lg:dark:border-zinc-800 lg:border-x-2">
            <NounsUploadForm account={this.props.account} />
          </div>
          <div className="bondingaccordion">
            <NounsAccordion address={this.props.account != null ? this.props.account.address : null} />
          </div>
          </div>
          {
            this.state.modalShown === 'createAccount'
              ?
            <Onboarding selectModal={this.selectModal} />
              :
            this.state.modalShown === 'addFunds'
              ?
            <AddFunds selectModal={this.selectModal} />
              :
            this.state.modalShown === 'importFromPassword'
              ?
            <ImportFromPassword selectModal={this.selectModal} />
              :
            null
          }
        </div>
      </div>
    );
  }
}

export default NounsUploadPage;
